export { loginUser, checkUserSelf, logoutUser } from './LoggedUser';
export { registerUser } from './register';

export const RESET = 'RESET';
export const reset = () => ({ type: RESET });
